export default __webpack_public_path__ + "static/media/logonotxt.4ddee396.png";